import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { customerShareIndicadores } from '../customer-share-indicador';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-customer-share-indicador-multiselect',
    templateUrl: './customer-share-indicador-multiselect.component.html',
    styleUrls: ['./customer-share-indicador-multiselect.component.less']
})
export class CustomerShareIndicadorMultiselectComponent {
    /** Indicadores de customer share selecionados */
    @Input() indicadores: number[];
    /** Ao alterar a seleção dos indicadores de customer share */
    @Output() indicadoresChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = false;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Indicador';
    @Input() checked = 'Indicador';
    @Input() checkedPlural = 'Indicadores';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum indicador encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-customer-share-indicador ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os indicadores de customer share para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        customerShareIndicadores.forEach(indicador => {
            selects.push({
                id: indicador.id,
                name: indicador.nome,
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção dos indicadores */
    onChange() {
        this.indicadoresChange.emit(this.indicadores);
    }
}
